import { Avatar, Color, Font, Hyperlink, Radius, Select, SelectProps, SelectSection, Spacing } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Draft, useProfileMutation, useStore } from 'zens-store'
import { useRouter } from 'zens-router'

import AuthInfo from './authinfo'

const transparentColor = 'transparent'

const styles = StyleSheet.create({
  container: {},
  value: {
    minWidth: 0,
    backgroundColor: transparentColor,
    borderColor: transparentColor,
  },
  arrow: {
    marginLeft: Spacing.XS,
  },
  content: {
    top: Spacing.XS,
    right: 0,
    backgroundColor: Color.simplyWhite,
    borderColor: Color.simplyWhite,
    borderTopStartRadius: Radius.S,
    borderTopEndRadius: Radius.S,
    shadowOffset: {
      width: 1,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 30,
    shadowColor: Color.premiumBlack,
    paddingVertical: Spacing.XS,
    minWidth: 320,
  },
  outline: {
    borderColor: transparentColor,
  },
  sectionTop: {
    borderColor: transparentColor,
  },
  sectionBottom: {
    paddingTop: Spacing.XS,
  },
  option: {
    width: '100%',
    marginVertical: 0,
  },
  info: {
    width: '100%',
    paddingHorizontal: Spacing.M,
    paddingVertical: Spacing.S,
  },
  action: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: Spacing.M,
    paddingVertical: Spacing.XS,
  },
  link: {
    fontFamily: Font.medium,
  },
  skeletonContainer: {
    paddingHorizontal: Spacing.S + 1,
    paddingVertical: 1,
  },
  skeletonContent: {
    width: 38,
    height: 38,
    borderRadius: 20,
    backgroundColor: Color.graphicGrey,
    marginRight: Spacing.S,
  },
})

interface Props extends SelectProps<string> {
  companyId: number
}

const MenuAuth = (props: Props) => {
  const { companyId, style, ...otherProps } = props
  const router = useRouter()
  const { auth } = useStore()
  const { profile } = auth
  const { t } = useTranslation()
  const mutation = useProfileMutation()

  const signOut = async () => {
    await mutation.signOut(new Draft({ id: 0, ...profile?.data }))
    router.push(`/email`)
  }

  const menu: SelectSection[] = [
    {
      items: [
        {
          value: 'avatar',
          render: () => <Avatar name={profile?.displayName} email={profile?.email} />,
        },
        ...(profile ? [<AuthInfo companyId={companyId} profile={profile} style={styles.info} key="profile" />] : []),
      ],
      style: styles.sectionTop,
    },
    {
      items: [
        <View style={styles.action} key="action">
          <Hyperlink title={t('Sign out')} textStyle={styles.link} onPress={signOut} testID="Auth.Logout" />
          {/* <Hyperlink title={t('Privacy & Terms')} textStyle={styles.link} disabled /> */}
        </View>,
      ],
      style: styles.sectionBottom,
    },
  ]
  return (
    <Select
      style={[styles.container, style]}
      valueStyle={styles.value}
      arrowStyle={styles.arrow}
      contentOutlineStyle={styles.outline}
      contentContainerStyle={styles.content}
      optionTextStyle={styles.option}
      value="avatar"
      items={menu}
      filterSelected
      testID="Auth.Select"
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {}

MenuAuth.Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.skeletonContainer, style]} {...otherProps}>
      <View style={styles.skeletonContent} />
    </View>
  )
}
export default MenuAuth
